import React from 'react';

import { decimalUpTo } from 'Helpers/currencyFormat';

const fmt = (value) => decimalUpTo(Number(value) || 0);

const Tile = ({ label, value, negative }) => (
    <div className="table__card tw-flex tw-flex-col tw-gap-y-1 tw-p-4">
        <span className="tw-text-xs tw-text-charcoal-75">{label}</span>
        <span className={negative && Number(value) < 0 ? 'tw-text-xl tw-font-semibold tw-text-red' : 'tw-text-xl tw-font-semibold'}>{fmt(value)}</span>
    </div>
);

const Partition = ({ label, part }) => (
    <div className="tw-space-y-2">
        <h5 className="text-dark-blue tw-py-1">{label}</h5>
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-3">
            <Tile label={$t('Risk weighted value')} value={part?.risks_weighted} />
            <Tile label={$t('Opportunity weighted value')} value={part?.opportunities_weighted} />
            <Tile label={$t('Net position')} value={part?.net} negative />
        </div>
    </div>
);

/**
 * Weighted-value summary format (IB-681): risk exposure, opportunity value and
 * net position (risks − opportunities), split in-AFC / not-in-AFC.
 */
const RadioWeightedValueSummary = ({ data, loading }) => {
    if (loading) {
        return <div className="tw-p-4 tw-text-sm">{$t('Loading...')}</div>;
    }

    if (!data) {
        return <div className="tw-p-4 tw-text-sm">{$t('No data available')}</div>;
    }

    return (
        <div className="tw-space-y-5">
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-3">
                <Tile label={$t('Risk weighted value')} value={data.risks_weighted} />
                <Tile label={$t('Opportunity weighted value')} value={data.opportunities_weighted} />
                <Tile label={$t('Net position')} value={data.net} negative />
                <Tile label={$t('Risk unweighted value')} value={data.risks_unweighted} />
                <Tile label={$t('Opportunity unweighted value')} value={data.opportunities_unweighted} />
            </div>

            <Partition label={$t('In AFC')} part={data.in_afc} />
            <Partition label={$t('Not in AFC')} part={data.not_in_afc} />
        </div>
    );
};

export default RadioWeightedValueSummary;
